import { __assign, __read, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import { useCallback, useEffect, useState, useMemo } from 'react';
import MoaStyledComponent from "../../Style/MoaStyled";
import TextField from '@mui/material/TextField';
import Color from '../../Style/Color';
import Font from '../../Style/Font';
import Tooltip from '../Tooltip';
var StyledComponent = styled(function (props) {
    var _a, _b, _c, _d, _e, _f;
    var error = props.error, others = __rest(props, ["error"]);
    var _g = __read(useState((props === null || props === void 0 ? void 0 : props.value) || (props === null || props === void 0 ? void 0 : props.defaultValue)), 2), localValue = _g[0], setLocalValue = _g[1];
    var _h = __read(useState(undefined), 2), tooltipText = _h[0], setTooltipText = _h[1];
    var _j = __read(useState(undefined), 2), errorOverride = _j[0], setErrorOverride = _j[1];
    var numberOptionsMin = useMemo(function () { var _a; return Number((_a = props === null || props === void 0 ? void 0 : props.numberOptions) === null || _a === void 0 ? void 0 : _a.min); }, [(_a = props === null || props === void 0 ? void 0 : props.numberOptions) === null || _a === void 0 ? void 0 : _a.min]);
    var numberOptionsMax = useMemo(function () { var _a; return Number((_a = props === null || props === void 0 ? void 0 : props.numberOptions) === null || _a === void 0 ? void 0 : _a.max); }, [(_b = props === null || props === void 0 ? void 0 : props.numberOptions) === null || _b === void 0 ? void 0 : _b.max]);
    var Text = useCallback(function (props) {
        var _a;
        return (_jsx(TextField, { autoFocus: props === null || props === void 0 ? void 0 : props.autoFocus, type: props === null || props === void 0 ? void 0 : props.type, onChange: props === null || props === void 0 ? void 0 : props.onChange, defaultValue: props === null || props === void 0 ? void 0 : props.defaultValue, error: props === null || props === void 0 ? void 0 : props.error, disabled: props === null || props === void 0 ? void 0 : props.disabled, value: props === null || props === void 0 ? void 0 : props.value, fullWidth: true, onBlur: props === null || props === void 0 ? void 0 : props.onBlur, sx: {
                height: (props === null || props === void 0 ? void 0 : props.height) || "auto",
                "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                        border: "1px solid ".concat(Color.component.gray),
                    },
                    "&:hover fieldset": {
                        border: "1px solid ".concat(Color.component.gray_02),
                    },
                    "&.Mui-focused fieldset": {
                        border: "1px solid ".concat(Color.component.gray_dark),
                    },
                },
                "& .MuiInputBase-input": {
                    padding: 0,
                },
                borderRadius: "0.25rem",
                background: Color.primary.white,
            }, InputProps: {
                // input component의 스타일 변경
                sx: __assign(__assign({}, ((props === null || props === void 0 ? void 0 : props.multiline) ? { height: "auto" } : { height: "1.75rem" })), { padding: "0.375rem 0.375rem 0.375rem 0.625rem", alignItems: "center", flexShrink: 0, 
                    //text
                    color: Color.text.secondary, fontFeatureSettings: Font.fontFeatureSettings }),
                inputProps: {
                    style: {
                        textAlign: props === null || props === void 0 ? void 0 : props.inputAlign,
                    },
                    min: numberOptionsMin || undefined,
                    max: numberOptionsMax || undefined,
                    step: (_a = props === null || props === void 0 ? void 0 : props.numberOptions) === null || _a === void 0 ? void 0 : _a.step,
                },
            }, placeholder: props === null || props === void 0 ? void 0 : props.placeholder, multiline: props === null || props === void 0 ? void 0 : props.multiline, rows: props === null || props === void 0 ? void 0 : props.rows, maxRows: props === null || props === void 0 ? void 0 : props.maxRows }));
    }, [numberOptionsMax, numberOptionsMin]);
    var errorResolver = useCallback(function (value) {
        if (typeof error === "function") {
            return error(value);
        }
        else {
            return error;
        }
    }, [error]);
    if ((props === null || props === void 0 ? void 0 : props.type) === "number") {
        useEffect(function () {
            var _a, _b, _c, _d;
            if (!Number.isNaN(numberOptionsMin) && !Number.isNaN(numberOptionsMax) && numberOptionsMin > numberOptionsMax) {
                setTooltipText("min is greater than max");
                setErrorOverride(true);
                return;
            }
            var txt = "";
            if (!Number.isNaN(numberOptionsMin)) {
                txt += "min value ".concat(((_b = (_a = props === null || props === void 0 ? void 0 : props.numberOptions) === null || _a === void 0 ? void 0 : _a.condition) === null || _b === void 0 ? void 0 : _b.min) === "greater" ? ">" : ">=", " ").concat(numberOptionsMin);
            }
            if (!Number.isNaN(numberOptionsMax)) {
                if (txt)
                    txt += "\n";
                txt += "max value ".concat(((_d = (_c = props === null || props === void 0 ? void 0 : props.numberOptions) === null || _c === void 0 ? void 0 : _c.condition) === null || _d === void 0 ? void 0 : _d.max) === "less" ? "<" : "<=", " ").concat(numberOptionsMax);
            }
            setTooltipText(txt);
            setErrorOverride(undefined);
        }, [(_d = (_c = props === null || props === void 0 ? void 0 : props.numberOptions) === null || _c === void 0 ? void 0 : _c.condition) === null || _d === void 0 ? void 0 : _d.max, (_f = (_e = props === null || props === void 0 ? void 0 : props.numberOptions) === null || _e === void 0 ? void 0 : _e.condition) === null || _f === void 0 ? void 0 : _f.min, numberOptionsMax, numberOptionsMin, props.type]);
        return (_jsx("div", { id: props === null || props === void 0 ? void 0 : props.id, "data-current-value": localValue, children: _jsx(Tooltip, { open: errorOverride, title: tooltipText, arrowBorder: true, children: _jsx(Text, __assign({}, others, { error: errorResolver(localValue) || errorOverride, onBlur: function (e) {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                        var value = Number(e.target.value);
                        setLocalValue(e.target.value);
                        if ((_a = props === null || props === void 0 ? void 0 : props.numberOptions) === null || _a === void 0 ? void 0 : _a.onlyInteger) {
                            value = Math.round(value);
                        }
                        if (!Number.isNaN(numberOptionsMin)) {
                            if (((_c = (_b = props === null || props === void 0 ? void 0 : props.numberOptions) === null || _b === void 0 ? void 0 : _b.condition) === null || _c === void 0 ? void 0 : _c.min) === "greater" &&
                                value <= numberOptionsMin) {
                                value = numberOptionsMin + 1;
                            }
                            else if (((_e = (_d = props === null || props === void 0 ? void 0 : props.numberOptions) === null || _d === void 0 ? void 0 : _d.condition) === null || _e === void 0 ? void 0 : _e.min) === "greaterEqual" &&
                                value < numberOptionsMax) {
                                value = numberOptionsMin;
                            }
                            else if (value <= numberOptionsMin) {
                                value = numberOptionsMin;
                            }
                        }
                        if (!Number.isNaN(numberOptionsMax)) {
                            if (((_g = (_f = props === null || props === void 0 ? void 0 : props.numberOptions) === null || _f === void 0 ? void 0 : _f.condition) === null || _g === void 0 ? void 0 : _g.max) === "less" &&
                                value >= numberOptionsMax) {
                                value = numberOptionsMax - 1;
                            }
                            else if (((_j = (_h = props === null || props === void 0 ? void 0 : props.numberOptions) === null || _h === void 0 ? void 0 : _h.condition) === null || _j === void 0 ? void 0 : _j.max) === "lessEqual" &&
                                value > numberOptionsMax) {
                                value = numberOptionsMax;
                            }
                            else if (value >= numberOptionsMax) {
                                value = numberOptionsMax;
                            }
                        }
                        e.target.value = value + "";
                        (_k = props === null || props === void 0 ? void 0 : props.onChange) === null || _k === void 0 ? void 0 : _k.call(props, e);
                    } })) }) }));
    }
    else {
        useEffect(function () {
            setTooltipText(undefined);
        }, []);
        return (_jsx("div", { id: props === null || props === void 0 ? void 0 : props.id, "data-current-value": localValue, children: _jsx(Text, __assign({}, others, { error: errorResolver(localValue), onBlur: function (e) { return setLocalValue(e.target.value); } })) }));
    }
})(function () { return ({
    display: "flex",
    fullWidth: true,
}); });
var ThemedComponent = function (props) { return (_jsx(MoaStyledComponent, { children: _jsx(StyledComponent, __assign({}, props)) })); };
export default ThemedComponent;
